import {AbsoluteFill, Sequence} from "remotion";
import {AnimatedTitle} from "../components/text/AnimatedTitle";
import {LowerThird} from "../components/text/LowerThird";
import {GradientBackground} from "../components/backgrounds/GradientBackground";
import {ParticleField} from "../components/backgrounds/ParticleField";
import {Watermark} from "../components/overlays/Watermark";
import {BRAND} from "../presets/brand";
import {loadDefaultFonts} from "../presets/fonts";

export const ShowcaseComposition: React.FC = () => {
  loadDefaultFonts();

  return (
    <AbsoluteFill>
      {/* Background */}
      <GradientBackground
        colors={[BRAND.colors.bg, "#1a1a3e"]}
        angle={135}
        animateAngle
        animateSpeed={0.5}
      />
      <ParticleField count={30} color={`${BRAND.colors.primary}25`} speed={0.3} />

      {/* Main title */}
      <Sequence from={0} durationInFrames={150}>
        <AbsoluteFill style={{justifyContent: "center", alignItems: "center"}}>
          <AnimatedTitle
            text={BRAND.name}
            fontSize={96}
            fontWeight={800}
            color={BRAND.colors.text}
            enterAnimation="scale"
            exitAnimation="blur"
            enterDuration={25}
            holdDuration={80}
            exitDuration={20}
            textShadow={`0 4px 30px ${BRAND.colors.primary}80`}
          />
        </AbsoluteFill>
      </Sequence>

      {/* Subtitle */}
      <Sequence from={30} durationInFrames={120}>
        <AbsoluteFill
          style={{
            justifyContent: "center",
            alignItems: "center",
            marginTop: 100,
          }}
        >
          <AnimatedTitle
            text={BRAND.tagline}
            fontSize={36}
            fontWeight={400}
            color={BRAND.colors.muted}
            enterAnimation="slideUp"
            exitAnimation="fade"
            enterDuration={20}
            holdDuration={60}
            exitDuration={15}
          />
        </AbsoluteFill>
      </Sequence>

      {/* Brand handle */}
      <Sequence from={60} durationInFrames={90}>
        <AbsoluteFill
          style={{
            justifyContent: "center",
            alignItems: "center",
            marginTop: 180,
          }}
        >
          <AnimatedTitle
            text={BRAND.handle}
            fontSize={28}
            fontWeight={600}
            color={BRAND.colors.primary}
            enterAnimation="fade"
            exitAnimation="fade"
            enterDuration={15}
            holdDuration={40}
            exitDuration={15}
          />
        </AbsoluteFill>
      </Sequence>

      {/* Second scene */}
      <Sequence from={160} durationInFrames={130}>
        <AbsoluteFill style={{justifyContent: "center", alignItems: "center"}}>
          <AnimatedTitle
            text="Built with Remotion + Claude Code"
            fontSize={64}
            fontWeight={700}
            color={BRAND.colors.text}
            enterAnimation="typewriter"
            exitAnimation="slideLeft"
            enterDuration={40}
            holdDuration={50}
            exitDuration={15}
          />
        </AbsoluteFill>
      </Sequence>

      {/* Lower third */}
      <Sequence from={170} durationInFrames={110}>
        <LowerThird
          name="Enrique Rocha"
          title={BRAND.handle}
          accentColor={BRAND.colors.primary}
          enterDuration={20}
          holdDuration={60}
          exitDuration={15}
        />
      </Sequence>

      {/* Watermark */}
      <Watermark
        text={BRAND.handle}
        corner="bottomRight"
        opacity={BRAND.watermark.opacity}
        fontSize={BRAND.watermark.fontSize}
        color={BRAND.colors.muted}
      />
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
